import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'language',
  pure: true
})
export class LanguagePipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('Unknown language');
    }
    const id = String(value);
    return this.lookupData.getLanguages({
      selectedIds: [id],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const found = result.items.find(l => String(l.id) === id);
        return found?.name ?? 'Unknown language';
      })
    );
  }
}
